import { Chip } from '@mui/material';
import type { AnnouncementCategory } from '../../lib/announcements-api';
import { useT } from '../../i18n';

const COLORS: Record<AnnouncementCategory, 'default' | 'warning' | 'error' | 'info' | 'success'> = {
  OUTAGE: 'error',
  MAINTENANCE: 'warning',
  GENERAL: 'info',
  SECURITY: 'success',
};

export const CATEGORY_KEY: Record<AnnouncementCategory, string> = {
  OUTAGE: 'ann.catOutage',
  MAINTENANCE: 'ann.catMaintenance',
  SECURITY: 'ann.catSecurity',
  GENERAL: 'ann.catGeneral',
};

export function CategoryChip({ category }: { category: AnnouncementCategory }) {
  const t = useT();
  return <Chip label={t(CATEGORY_KEY[category] ?? category)} color={COLORS[category]} size="small" variant="filled" />;
}
